import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />;
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      width: '100%' 
    }}>
      <Spin indicator={antIcon} tip="Caricamento..." />
    </div>
  );
};

export default LoadingSpinner;